import { render, staticRenderFns } from "./BaseAddFile.vue?vue&type=template&id=f3f43740&"
import script from "./BaseAddFile.vue?vue&type=script&lang=js&"
export * from "./BaseAddFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports